import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { PromptsService } from "./services/Prompts.services";
import { SearchContext } from "@/shared/models/SearchContext";
import {
  COMPONENT_NAME_MODAL,
  LIST_DATA_EVENTS
} from "@/shared/constants/FormConstants";
import store from "@/store";
import {
  GENERAL_CONSTANTS,
  KEYTYPE_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import {
  ADD_PROMPT_TEXT,
  PAGE_PROMPTS_TITLE_CREATE,
  PAGE_PROMPTS_TITLE_SEARCH,
  PROMPTS_FILTERS
} from "./constants/prompts.constants";
import { Http } from "@status/codes";
import { PromptQuery } from "./models/PromptQuery";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import SavePrompt from "./components/SavePrompt/SavePrompt.vue";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { mapGetters } from "vuex";

@Component({
  name: "Prompts",
  components: { SavePrompt },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView",
      dataToLateralMenu: "getDataToLateralMenu"
    })
  }
})
export default class Prompts extends Vue {
  @Inject() promptsService!: PromptsService;

  dataToMainView!: MenuDataStructure;
  dataToLateralMenu!: MenuDataStructure;

  filterArray = PROMPTS_FILTERS.MAIN;
  OPERATIONS = [
    /*LIST_DATA_EVENTS.DELETE_DATA*/
  ];
  loadingData = false;
  itemList: never[] = [];
  canSearch = true;
  promtList: any = [];
  querySearch: PromptQuery = {};
  docRef = "";
  currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
  tooltip = ADD_PROMPT_TEXT;
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  isVisibleSavePrompt = false;
  promptId = "";
  key = 0;

  mounted() {
    console.log("Prompts mounted");
    this.searchPrompts(true);
    this.emitSearchInitializer();
  }

  async emitSearchInitializer() {
    await this.initializeFilters();

    const searchContext: SearchContext = {
      title: PAGE_PROMPTS_TITLE_SEARCH,
      filterArray: [this.filterArray],
      operations: this.OPERATIONS,
      clickAction: LIST_DATA_EVENTS.EDIT_DATA,
      componentName: COMPONENT_NAME_MODAL.USER,
      callbackHandleOperation: this.handleOperation,
      descriptions: ["state"],
      textButtonCreate: PAGE_PROMPTS_TITLE_CREATE
    };
    const data = searchContext;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      data
    );
  }

  async initializeFilters() {
    const secondaryFilters = [];
    secondaryFilters.push(PROMPTS_FILTERS.SECONDARY.NAME);
    secondaryFilters.push(PROMPTS_FILTERS.SECONDARY.STATUS);
    this.filterArray.secondaryFilters = secondaryFilters;
  }

  // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
  sendDataToLateralMenu(action: string, data?: any) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  async handleOperation(action: string, itemId: string) {
    console.log("action", action);
    switch (action) {
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.editPromt(itemId);
        break;
    }
  }

  editPromt(promptId: string) {
    console.log("editPromt", promptId);
    this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
    this.promptId = promptId;
    this.key++;
    this.isVisibleSavePrompt = true;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
      promptId
    );
  }

  @Watch("dataToMainView")
  handleDataToMainView() {
    const validations: Record<string, void> = {
      Panel: this.panelValidation()
    };

    validations[this.dataToMainView.from];
  }

  panelValidation() {
    /* istanbul ignore else */
    if (this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE:
          this.querySearch = this.dataToMainView.data;
          this.searchPrompts(true);
          break;
      }
    }
  }

  async searchPrompts(shouldSearch: boolean) {
    if (!shouldSearch) return;
    this.loadingData = true;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT_AND_HIDE_CARDS
    );

    this.itemList = [];
    this.canSearch = false;
    this.promtList = await this.getData(false);
    if (
      this.promtList?.code === Http.Found &&
      this.promtList?.data !== undefined
    ) {
      this.itemList = this.promtList.data;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
        this.itemList
      );
      this.docRef = this.promtList.data.lastReference || "";
      this.canSearch = true;
    } else {
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
      if (this.promtList.code === Http.NotFound) {
        Snackbar.popInfo(this.promtList.message);
      } else {
        Snackbar.popError(this.promtList.message);
      }
    }

    this.loadingData = false;
  }

  async getData(loadPages?: boolean) /*: Promise<Response<UserPagination>>*/ {
    try {
      const filterQuery: PromptQuery = {};
      console.log("this.querySearch", this.querySearch);
      if (typeof this.querySearch !== KEYTYPE_CONSTANTS.UNDEFINED) {
        if (this.querySearch?.name) filterQuery.name = this.querySearch.name;
        if (this.querySearch?.promptState)
          filterQuery.promptState = this.querySearch.promptState;
      }

      if (loadPages) {
        filterQuery.idReference = this.docRef;
      }

      const data = await this.promptsService.getPromptsByFilters(filterQuery);

      return data;
    } catch (error) {
      // let responseError: Response<UserPagination>;
      if ((error as Error).message === GENERAL_CONSTANTS.FORBIDDEN) {
        /*    responseError = {
                     code: Http.Forbidden,
                     message: FORM_MESSAGES.FORBIDDEN_REQUEST + 'consultar prompts',
                     data: { userArray: [], lastReference: "" }
                   }; */
      } else {
        /*  responseError = {
                   code: Http.BadRequest,
                   message: FORM_MESSAGES.REQUEST_FAILED,
                   data: { userArray: [], lastReference: "" }
                 }; */
      }
      //    return responseError;
    }
  }

  onButtonAdd() {
    this.promptId = "";
    if (this.currentIcon == GENERAL_CONSTANTS.ICONS.CANCEL) {
      this.isVisibleSavePrompt = false;
      this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
      return;
    }
    this.isVisibleSavePrompt = true;
    this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
    this.promptId = "";
    this.key++;
  }

  onPromptSaved() {
    this.isVisibleSavePrompt = false;
    this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
    this.searchPrompts(true);
  }
}
